import { BaseModel } from './base.model'
import { CenterProgram } from './center-program.model'
import { ProgramSection } from './program-section.model'
import { MotivationVideo } from './motivation-video.model'

export class Program extends BaseModel<Program> {
  static DEFAULT_ATTRIBUTES = {
    centerIds: [],
    centerPrograms: [],
    sections: [],
    nestedProgramIds: [],
    yandexMinExportGradeEnabled: false,
    minGrade: 3,
    motivationVideos: [],
    requiredApi: 2,
    rehabilitation: false
  }

  centerIds: number[]
  centerPrograms: CenterProgram[]
  comment: string
  completedSessionsCount: number
  folderId: number
  id: number
  name: string
  password: string
  sections: ProgramSection[]
  startExamConfigId: number
  state: string
  timeLimit: number
  minGrade: number
  yandexMinExportGrade: number
  yandexMinExportGradeEnabled: boolean
  parentId: number
  nestedProgramIds: number[]
  course: string
  equivalentIds: number[]
  motivationVideos: MotivationVideo[]
  requiredApi: number
  rehabilitation: boolean
  kioskUuid: string
  
  removed(): boolean {
    return this.state == 'removed'
  }

  disabled(): boolean {
    return this.state == 'disabled'
  }

  get timeLimitMinutes(): number {
    if(this.timeLimit) {
      return Math.round(this.timeLimit / 60 * 100) / 100
    } else {
      return this.timeLimit
    }
  }

  set timeLimitMinutes(minutes: number) {
    this.timeLimit = minutes ? minutes * 60 : minutes
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/program.model.ts